module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "form-control",
    attrs: {
      "name": _vm._name,
      "placeholder": _vm.spec.placeholder,
      "readonly": _vm._readonly
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b3ccb9ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-textarea.vue
// module id = 530
// module chunks = 55